import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLiff } from "react-liff";

import MainLayout from "./layouts/MainLayout";
import PageLoader from "./components/loader/PageLoader";

import AppRouter from "./appRouter"; // Router

import { setProfile } from "./features/ProfileSlice";
import { accessToken } from "./services/Api/Module/Customer";

import VConsole from "vconsole";

// const devMode = false;

async function retry(fn, retries = 3) {
  try {
    return await fn();
  } catch (e) {
    if (retries <= 0) throw e;
    await new Promise((r) => setTimeout(r, 1000));
    return retry(fn, retries - 1);
  }
}

function readLineUidFromIdToken(liff) {
  try {
    return liff.getDecodedIDToken()?.sub || null;
  } catch {
    return null;
  }
}

function App() {
  const dispatch = useDispatch(); // ไว้อัพเดต state กลาง
  const stateProfile = useSelector((state) => state.profile);

  const [isLoadedProfile, setIsLoadedProfile] = useState(false);
  const [isHasProfile, setIsHasProfile] = useState(false);

  let { error, isLoggedIn, isReady, liff } = useLiff();

  // if (!isLoggedIn && devMode) {
  //   isLoggedIn = devMode; // mock true เอาไว้ dev
  // }

  const initialized = useRef(false);

  useEffect(() => {
    // console.log("isLoggedIn >>", isLoggedIn);

    if (error) {
      console.warn(error);
      return;
    }

    if (!isReady || !liff) return;

    if (!isLoggedIn) return;

    if (!initialized.current) {
      initialized.current = true;

      (async () => {
        try {
          let lineUid = null;

          try {
            const profile = await retry(() => liff.getProfile());
            if (profile?.userId) {
              lineUid = profile.userId;
              window.localStorage.setItem("line_uid", lineUid);
            }
          } catch (profileErr) {
            console.warn(profileErr);
            console.warn(
              "ระบบ LINE ขัดข้อง ใช้งานข้อมูลเดิมแทน (cache / ID token)"
            );
            lineUid =
              window.localStorage.getItem("line_uid") ||
              readLineUidFromIdToken(liff);
          }

          if (!lineUid) {
            lineUid =
              readLineUidFromIdToken(liff) ||
              window.localStorage.getItem("line_uid");
          }

          if (lineUid && !window.localStorage.getItem("line_uid")) {
            window.localStorage.setItem("line_uid", lineUid);
          }

          if (!lineUid) {
            console.warn("ไม่พบ LINE UID จาก profile, cache หรือ ID token");
            setIsLoadedProfile(true);
            setIsHasProfile(false);
            return;
          }

          const tmpObj = { lineUid };

          getAccessToken({ lineUid }).then((_rsData) => {
            if (_rsData.status === true) {
              if (typeof _rsData.result.token !== "undefined") {
                window.localStorage.setItem("token", _rsData.result.token);

                setIsHasProfile(true);
              }

              dispatch(setProfile(tmpObj));

              setIsLoadedProfile(true);
            } else {
              setIsLoadedProfile(true);
              setIsHasProfile(false);
            }
          });
        } catch (err) {
          console.warn(err);
          setIsLoadedProfile(true);
          setIsHasProfile(false);
        }
      })();
    }
  }, [liff, isLoggedIn, isReady, error, dispatch]);

  useEffect(() => {
    // console.log("isLoadedProfile >>", isLoadedProfile, isHasProfile);

    if (isLoadedProfile) {
      const vConsole = new VConsole();
    }
  }, [isLoadedProfile, isHasProfile]);

  const getAccessToken = async (payload) => {
    let _return = {
      status: false,
      result: null,
    };

    try {
      const { data } = await accessToken({ lineUid: payload.lineUid });
      if (data.resultCode === 20200) {
        const resData = data.body;
        // console.log("getAccessToken resData >>", resData);

        _return.status = true;
        _return.result = resData;
      }
    } catch (e) {
      console.log("ERR getAccessToken >> ", e);
    }

    return _return;
  };

  return (
    <>
      {!isReady ? (
        <PageLoader />
      ) : !isLoadedProfile ? (
        <PageLoader />
      ) : (
        <MainLayout>
          <AppRouter isHasProfile={isHasProfile} profileData={stateProfile} />
        </MainLayout>
      )}
    </>
  );
}

export default App;
